import React, { useCallback, FC } from "react";
import { useLocation, useHistory } from "react-router-dom";
import { Select } from "../app/ui/select";


interface SelectActionProps {
  children: React.ReactNode;
  "url-variable-key": string;
  value: string;
  resetOnValueChange?: boolean;
  resetKeys?: string[];
}

export const SelectAction: FC<SelectActionProps> = ({
  children,
  "url-variable-key": key,
  value,
  resetOnValueChange,
  resetKeys,
}) => {
  const location = useLocation();
  const history = useHistory();

  const createQueryString = useCallback(
    (name: string, value: string) => {
      const params = new URLSearchParams(location.search);

      if (resetOnValueChange) {
        params.forEach((_, paramKey) => {
          if (paramKey !== name) params.delete(paramKey);
        });
      }
      if (resetKeys) {
        resetKeys.forEach((resetKey) => params.delete(resetKey));
      }

      params.set(name, value);

      return params.toString();
    },
    [location.search, resetKeys, resetOnValueChange]
  );

  const handleValueChange = (e: string) => {
    const newQueryString = createQueryString(key, e);
    history.push(`${location.pathname}?${newQueryString}`);
  };

  return (
    <Select value={value} onValueChange={handleValueChange}>
      {children}
    </Select>
  );
};

type TriggerActionProps = {
  children: React.ReactNode;
  serverAction: () => void;
  className?: string;
};

export const TriggerAction: FC<TriggerActionProps> = ({
  children,
  serverAction,
  className,
}) => {
  return (
    <button className={className || ""} onClick={serverAction}>
      {children}
    </button>
  );
};
